import { graphql } from 'gql';

export const bimOrderRequisitesGql = graphql(`
    query bimWorkOrder($workOrderId: Long!) {
        bimWorkOrder(workOrderId: $workOrderId) {
            data {
                id
                status
                statusFollowers
                formationStage
                subject
                internalNumber
                signingDate
                startDate
                finishDate
                contractor
                seasons {
                    workOrderId
                    workOrderSeasonId
                    id
                    year
                }
                seasonDistributions {
                    seasonValue
                    workOrderSeasonId
                }
                amountWithTax
                amountWithoutTax
                tax
                createdAt
                remainder
                updatedAt
                authoredBy
                updatedBy
                hasActsKC2
                hasOtherActsKC2
                hasSMRActsKC2
                isWorkOrderChangeRequired
                workOrderChange {
                    id
                    internalNumber
                    signingDate
                }
            }
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const updateBimOrderRequisitesGql = graphql(`
    mutation bimUpdateWorkOrder($workOrderInput: BimWorkOrderUpdateInput!) {
        bimUpdateWorkOrder(workOrderInput: $workOrderInput) {
            data {
                id
                isWorkOrderChangeRequired
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCalculationRequisitesGql = graphql(`
    query bimCalculationRequisites($workOrderId: Long!) {
        bimCalculation(workOrderId: $workOrderId) {
            data {
                id
                status
                statusFollowers
                seasons {
                    id
                    workOrderId
                    workOrderSeasonId
                    year
                }
                seasonDistributions {
                    workOrderSeasonId
                    seasonValue
                }
                hasActsKC2
                hasSMRActsKC2
                hasOtherActsKC2
                isWorkOrderChangeRequired
            }
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const bimUpdateCalculationRequisitesGql = graphql(`
    mutation bimUpdateCalculation($calculationInput: BimCalculationUpdateInput!) {
        bimUpdateCalculation(calculationInput: $calculationInput) {
            data {
                id
                isWorkOrderChangeRequired
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
